export const getCustomerName = (jobOpp = {}) => {
  const organizationName = jobOpp?.organization;
  const customerName =
    jobOpp?.customer?.companyDetails?.name || jobOpp?.customer?.company;

  return organizationName || customerName;
};
